export default "__VITE_ASSET__y5Afx3FL__"